import React, { Component } from 'react';
import { Breadcrumb } from '@blueprintjs/core'
import ReactGA from 'react-ga'
import { base, app } from '../../base'
import CommentList from './CommentList'


class Notes extends Component {
    constructor(props) {
        super(props)
        this.addComment = this.addComment.bind(this)
        this.createComment = this.createComment.bind(this)
        this.state = {
            comments: {},
            user: app.auth().currentUser
    }
}




    addComment(comment) {
        const comments = { ...this.state.comments }
        const id = Date.now();
        comments[id] = {
            id: id,
            comment: comment,
            owner: this.state.user.uid
        }

        this.setState({comments})

    }
    createComment(event) {
        event.preventDefault()
    
        const comment = this.commentInput.value
        this.addComment(comment)  

      }



    componentWillMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
        this.userRef = base.syncState(`userData/${this.state.user.uid}`, {
            context: this,
            state: 'comments'
          });
    }
  
    componentWillUnmount() {
        base.removeBinding(this.userRef);
      }
    render() {
        return (
            <div>
                <ul className="pt-breadcrumbs">
                    <li><Breadcrumb href="/home" text="Home" /></li>
                    <li><Breadcrumb href="/blog" text="Blog" /></li>
                </ul>
                <hr />
                <div>
                    <h3>Blog</h3>
                    <div>
                        <div>
                            <form onSubmit={(event) => this.createComment(event)} ref={(form) => this.commentForm = form}>
                                <label className="pt-label">
                                    Comment 
            <input style={{ width: "100%" }} className="pt-input" name="comment" type="text" ref={(input) => { this.commentInput = input }} placeholder="Enter a Remark here"></input>
                                </label>
                                <input style={{ width: "100%" }} type="submit" className="pt-button pt-intent-primary" value="Create Comment"></input>
                            </form>
                        </div>
                    </div>
                </div>
                <CommentList comments={this.state.comments} />

            </div>

        );
    }
}

export default Notes;


// WEBPACK FOOTER //
// ./src/components/Notes/Notes.jsx